class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    const details = this.querySelector('details');
    if (!details) {
      this.mainDetailsToggle = null;
      this.content = null;
      return;
    }

    this.mainDetailsToggle = details;
    const summary = details.querySelector('summary');
    this.content = summary ? summary.nextElementSibling : null;

    details.addEventListener('focusout', this.onFocusOut.bind(this));
    details.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.content || !this.mainDetailsToggle) return;
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    const details = this.mainDetailsToggle;
    if (!details) return;
    details.removeAttribute('open');
    const summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header || !this.mainDetailsToggle) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

